var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "../../services/customAxios", "../../../modules/models/serviceResponse"], function (require, exports, customAxios_1, serviceResponse_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    customAxios_1 = __importDefault(customAxios_1);
    serviceResponse_1 = __importDefault(serviceResponse_1);
    var TermAccessDocumentRequest = (function () {
        function TermAccessDocumentRequest() {
        }
        TermAccessDocumentRequest.prototype.verifyAccessDocument = function (payload) {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter(this, void 0, void 0, function () {
                var response, error_1;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            _g.trys.push([0, 2, , 3]);
                            return [4, customAxios_1.default.post("/" + TermAccessDocumentRequest._controller + "/documento-acesso/verificar", payload)];
                        case 1:
                            response = _g.sent();
                            if (!this.IsResponseValid(response))
                                Promise.reject(serviceResponse_1.default.Error((_a = response.data) === null || _a === void 0 ? void 0 : _a.data, (_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : TermAccessDocumentRequest._defaultErrorMessage));
                            return [2, Promise.resolve(serviceResponse_1.default.Success((_d = response.data) === null || _d === void 0 ? void 0 : _d.data, (_f = (_e = response.data) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : TermAccessDocumentRequest._defaultErrorMessage))];
                        case 2:
                            error_1 = _g.sent();
                            console.error(error_1);
                            Promise.reject(serviceResponse_1.default.Error(null, TermAccessDocumentRequest._defaultErrorMessage));
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        };
        TermAccessDocumentRequest.prototype.sendAccessDocument = function (payload) {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function () {
                var response, error_2;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            _f.trys.push([0, 2, , 3]);
                            return [4, customAxios_1.default.post(TermAccessDocumentRequest._controller + "/token", payload)];
                        case 1:
                            response = _f.sent();
                            if (!this.IsResponseValid(response))
                                Promise.reject(serviceResponse_1.default.Error((_a = response.data) === null || _a === void 0 ? void 0 : _a.data, (_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : TermAccessDocumentRequest._defaultErrorMessage));
                            return [2, Promise.resolve(serviceResponse_1.default.Success((_d = response.data) === null || _d === void 0 ? void 0 : _d.data, (_e = response.data.message) !== null && _e !== void 0 ? _e : TermAccessDocumentRequest._generateTermErrorMessage))];
                        case 2:
                            error_2 = _f.sent();
                            console.error(error_2);
                            Promise.reject(serviceResponse_1.default.Error(null, TermAccessDocumentRequest._generateTermErrorMessage));
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        };
        TermAccessDocumentRequest.prototype.IsResponseValid = function (response) {
            return response.status >= 200 && response.status <= 299;
        };
        TermAccessDocumentRequest._controller = "cliente";
        TermAccessDocumentRequest._defaultErrorMessage = "Ocorreu um erro ao tentar verificar o documento de acesso";
        TermAccessDocumentRequest._generateTermErrorMessage = "Ocorreu um erro ao tentar gerar o termo.";
        return TermAccessDocumentRequest;
    }());
    exports.default = TermAccessDocumentRequest;
});
